










import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { DirectiveBinding } from 'vue/types/options'
import { VNode } from 'vue/types/umd'

import OutputSocket from '../../../components/Socket/OutputSocket.vue'
import { SampleNodeMixin } from '../../Nodes'
import { StartNode } from './StartNode'

@Component({
  components: {
    OutputSocket
  },
  directives: {
    socket: {
      bind(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      },
      update(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      }
    },
  }
})
export default class SampleStartNode extends SampleNodeMixin {
  @Prop() node!: StartNode

  get output() {
    if (this.node.mainOutput) {
      return Vue.observable(this.node.outputs.get(this.node.mainOutput))
    }

    return undefined
  }
}
